import { Component, OnInit } from '@angular/core';
import { SidebarStateService } from '../../../services/sidebar-state/sidebar-state.service';
import { CommonModule } from '@angular/common';
import { UserInfoComponent } from '../../units/zikata-user-info/zikata-user-info.component';
import IZikataClientProfile, {
  UserInfoConfigService,
  UserRole,
} from '../../../services/user-info-config/user-info-config.service';

@Component({
  selector: 'zikatagov-header',
  template: `
    <nav
      class="navbar navbar-dark bg-zikata"
      [ngClass]="{ 'header-expanded': !isCollapsed }"
    >
      <div class="container-fluid">
        <div class="row w-100">
          <!-- Left side space -->
          <div class="col"></div>
          <!-- Right-aligned content -->
          <div class="col-auto align-self-end mpx-0">
            <zikatagov-user-info
              [userProfile]="userProfile"
              [userRole]="rolesString"
              [avatarSize]="40"
            >
            </zikatagov-user-info>
          </div>
        </div>
      </div>
    </nav>
  `,
  standalone: true,
  imports: [CommonModule, UserInfoComponent],
  styles: [
    `
      .bg-zikata {
        background-color: #2e005d;
      }
      .navbar {
        transition: margin-left 0.3s ease;
      }
      :host ::ng-deep .mobile-menu {
        right: 1rem; /* Add some spacing from the right edge in mobile view */
      }
    `,
  ],
})
export class HeaderComponent implements OnInit {
  fullName = '';
  rolesString = '';
  isCollapsed = false;
  userProfile?: IZikataClientProfile;

  constructor(
    private sidebarStateService: SidebarStateService,
    private userInfoConfigService: UserInfoConfigService
  ) {}

  ngOnInit() {
    // Subscribe to sidebar state
    this.sidebarStateService.isCollapsed$.subscribe(
      (isCollapsed) => (this.isCollapsed = isCollapsed)
    );

    // Load user account details
    this.loadUserAccount();
  }

  private loadUserAccount() {
    this.userInfoConfigService.getUserAccount().subscribe({
      next: (profile) => {
        this.userProfile = profile;
        this.formatUserInfo(profile);
      },
      error: (error) => {
        console.error('Error loading user account:', error);
        // Set fallback values in case of error
        this.fullName = 'Guest User';
        this.rolesString = 'Unknown Role';
      },
    });
  }

  private formatUserInfo(profile: IZikataClientProfile) {
    // Format full name
    this.fullName = this.formatFullName(profile);

    // Format roles
    this.rolesString = this.formatRoles(profile.userRoles);
  }

  private formatFullName(profile: IZikataClientProfile): string {
    const nameParts = [
      profile.firstName,
      profile.middleName,
      profile.lastName,
    ].filter(Boolean); // Remove empty/null/undefined values

    return nameParts.join(' ');
  }

  private formatRoles(roles: UserRole[]): string {
    if (!roles || roles.length === 0) {
      return 'No Role';
    }

    // Map through roles and get their names/titles, then join them with commas
    return roles.map((role) => role.role).join(', ');
  }
}
